<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>Texto da Resposta</th>
          <th>Status (Ativo)</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="resposta in respostas" :key="resposta.id">
          <td data-label="Texto:">
            <span>{{ resposta.texto }}</span>
          </td>
          <td data-label="Ativo:">
            <span>{{ resposta.ativo ? 'Sim' : 'Não' }}</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <div class="icone-tabela">
                <router-link :to="{ name: 'RespostaShow', params: { id: resposta.id } }">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
              </div>
              <template v-if="!resposta.vinculada_a_formulario && podeEscrever('respostas')">
                <div class="icone-tabela">
                  <router-link :to="{ name: 'RespostaEdit', params: { id: resposta.id } }">
                    <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                  </router-link>
                </div>
                <span class="icone-tabela" type="button" @click="opcoesExcluir(resposta.id)">
                  <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
                </span>
              </template>
            </div>
          </td>
          <div class="modal-exclusao" :id="resposta.id">
            <div class="modal-mask">
              <div class="modal-container">
                <div class="modal-header">
                  <h2>Deseja mesmo excluir esta Resposta?</h2>
                </div>
                <div class="modal-body">
                  <p>Dados da Resposta:</p>
                  <div class="dados">
                    <div class="texto-centralizado">
                      Texto: <span>{{ resposta.texto }}</span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn-confirmar-exclusao" @click="excluirLinha(resposta.id)">Sim</button>
                  <button class="btn-cancelar-exclusao" @click="opcoesExcluir(resposta.id)">Não</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        <tr v-if="!respostas || respostas.length === 0" class="sem-resultados">
            <td colspan="3"><p><b>Nenhum Resultado Encontrado</b></p></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import MsgErroFormularios from "../MsgErroFormularios";
  import RespostaApi from "../../services/RespostaApi";

  export default {
    name: "TabelaResultadosRespostas",
    props: {
      respostas: Array,
    },
    components: {
      MsgErroFormularios,
    },
    data() {
      return {
        msgErros: {
          resposta: '',
        },
        erro: false,
      };
    },
    created() {
      this.respostaApi = new RespostaApi();
    },
    methods: {
      opcoesExcluir(respostaId) {
        let modalExclusao = document.getElementsByClassName('modal-exclusao');
        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == respostaId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible";
            } else {
              modalExclusao[i].style.visibility = "hidden";
            }
          }
        }
      },
      
      async excluirLinha(respostaId) {
        this.opcoesExcluir(respostaId);
        try {
          this.erro = false;
          await this.respostaApi.destroyResposta(respostaId);
          window.location.reload();
        } catch (err) {
          this.erro = true;
          this.msgErros.resposta = "Não foi possível excluir a resposta, pois ela está vinculada a um Formulário.";
          console.error(err);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media screen and (min-width: "1066px") {
    .resultados {
      table {
        tbody {
          tr {
            td {
              padding: 1rem .7rem;
              vertical-align: middle;
              text-align: center;
            }

            td:nth-child(1) {
              min-width: 9rem;
              padding: .9rem;
              text-align: left;
            }
          
            td:nth-child(2) {
              text-align: center;
            }            

            td:nth-child(3) {
              text-align: left;
            }

            td:nth-child(4) {
              text-align: left;
            }

            td:nth-child(5) {
              text-align: left;
              max-width: 50rem;
            }
          }

          .coluna-acoes-tabela {
            
            text-align-last: center;

            .icone-tabela {
              width: fit-content;
              display: inline-block;
              background-color: #fff;
              margin: 0 .05rem 0 .05rem;
            }
          }
        }
      }
    }
  }
  .modal-exclusao {
    visibility: hidden;
  }
  .texto-centralizado {
    text-align: center;
    margin-bottom: 0.5rem;
  }
</style>